export enum ListMarker {
    None = 'none',
    LowercaseLetter = 'a',
    UppercaseLetter = 'A',
    Numeral = '1',
    LowercaseRomanNumeral = 'i',
    UppercaseRomanNumeral = 'I',
}
